<template>
  <v-snackbar
    v-model="display"
    :timeout="message.timeout"
    :color="message.status"
    top
    right
  >
    <span>{{ text }}</span>

    <template #action="{ attrs }">
      <v-btn
        dark
        text
        v-bind="attrs"
        @click="display = false"
      >
        Закрыть
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'Message',
  computed: {
    ...mapState({
      message: state => state.message,
    }),

    text() {
      const text = this.message.text || ''

      return /^[A-Z_]+\.[A-Za-z]+$/.test(text) ? '' : text
    },
    display: {
      get() { return this.$store.state.message.display },
      set() { this.$store.dispatch('message/clear') },
    },
  },
}
</script>
